import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const Accessibility24pxIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2C11 0.9 10.1 0 9 0C7.9 0 7 0.9 7 2C7 3.1 7.9 4 9 4C10.1 4 11 3.1 11 2ZM12 7H17C17.55 7 18 6.55 18 6C18 5.45 17.55 5 17 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7H6V19C6 19.55 6.45 20 7 20C7.55 20 8 19.55 8 19V14H10V19C10 19.55 10.45 20 11 20C11.55 20 12 19.55 12 19V7Z"
        fill={color}
      />
    </IconBase>
  );
};

export default Accessibility24pxIcon;
